import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts } from '../../../settings';
import { DelayLink } from '../../../components';

import './Card9.scss';

class Card9 extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Suspensão das provas estimula capacitação - Iniciativas - {texts.title}</title>
        </Helmet>

        <div className="iniciativas-home card9-home page-gradient page-gradient--yellow bg-gray" ref="card9-home">
          <section className="iniciativas-area card9-area page--yellow">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to="/estrategias/para-o-mercado"
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title">Suspensão das provas estimula capacitação</h1>
                        </div>
                        <div className="card__content__body">
                          <div className="row flex">
                            <div className="col-12">
                              <p>
                                Em um ano de crise sanitária global, nossos exames de certificação tiveram um calendário
                                atípico, mas nem por isso reduzimos as iniciativas de desenvolvimento dos profissionais
                                de mercado. Pelo contrário, reforçamos a comunicação com eles e disponibilizamos,
                                gratuitamente, todos os cursos da nossa plataforma de educação continuada, decisão que
                                será mantida no pós-pandemia. Com isso, a procura pelos cursos aumentou: recebemos
                                255.274 inscrições em 2020, volume quase 15 vezes superior ao registrado em 2019.
                              </p>
                              <p>
                                Devido à pandemia de coronavírus, as provas da CPA-10, CPA-20, CEA e CGA foram
                                completamente suspensas em 16 de março e retomadas, gradualmente, a partir 23 de julho,
                                nos centros de testes de cidades onde não existiam restrições que impedissem seu
                                funcionamento.
                              </p>
                              <p>
                                Aprimoramos a comunicação com os interessados nas certificações, criando, por exemplo,
                                uma página em nosso site com um mapa de reabertura que mostrava onde os exames estavam
                                sendo aplicados, com atualização periódica.
                              </p>
                              <h3>Flexibilização</h3>
                              <p>
                                Em maio, liberamos temporariamente a contratação de profissionais não certificados pelas
                                instituições aderentes ao Código de Certificação e aquelas em processo de adesão, desde
                                que firmassem o compromisso de regularizar a situação quando o calendário de provas
                                fosse retomado plenamente, o que não ocorreu até o final de 2020. Nosso plano é, assim
                                que a oferta de exames for retomada, estabelecer um prazo de três meses para a
                                certificação dos profissionais que necessitam da CPA-10, CPA-20 e CEA e de seis meses
                                para as demais certificações.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-12 box">
                  <h1 className="title">Certificações emitidas em 2020 por região</h1>
                  <div className="desk">
                    <div className="row center">
                      <div className="col-2"></div>
                      <div className="col-2">
                        <p>Norte</p>
                      </div>
                      <div className="col-2">
                        <p>Nordeste</p>
                      </div>
                      <div className="col-2">
                        <p>Centro-Oeste</p>
                      </div>
                      <div className="col-2">
                        <p>Sul</p>
                      </div>
                      <div className="col-2">
                        <p>Sudeste</p>
                      </div>
                    </div>

                    <div className="row bg-light-grey green center">
                      <div className="col-2">
                        <img src={images.iniciativas.card9.img1} className="card9-icons" />
                      </div>
                      <div className="col-2">
                        <h3>678</h3>
                      </div>
                      <div className="col-2">
                        <h3>2.026</h3>
                      </div>
                      <div className="col-2">
                        <h3>1.773</h3>
                      </div>
                      <div className="col-2">
                        <h3>3.983</h3>
                      </div>
                      <div className="col-2">
                        <h3>8.079</h3>
                      </div>
                    </div>

                    <div className="row bg-light-grey blue center">
                      <div className="col-2">
                        <img src={images.iniciativas.card9.img2} className="card9-icons" />
                      </div>
                      <div className="col-2">
                        <h3>487</h3>
                      </div>
                      <div className="col-2">
                        <h3>1.704</h3>
                      </div>
                      <div className="col-2">
                        <h3>1.631</h3>
                      </div>
                      <div className="col-2">
                        <h3>3.086</h3>
                      </div>
                      <div className="col-2">
                        <h3>8.459</h3>
                      </div>
                    </div>

                    <div className="row bg-light-grey center">
                      <div className="col-2">
                        <img src={images.iniciativas.card9.img3} className="card9-icons" />
                      </div>
                      <div className="col-2">
                        <h3>69</h3>
                      </div>
                      <div className="col-2">
                        <h3>394</h3>
                      </div>
                      <div className="col-2">
                        <h3>401</h3>
                      </div>
                      <div className="col-2">
                        <h3>661</h3>
                      </div>
                      <div className="col-2">
                        <h3>2.564</h3>
                      </div>
                    </div>

                    <div className="row bg-light-grey dark-grey center">
                      <div className="col-2">
                        <img src={images.iniciativas.card9.img4} className="card9-icons" />
                      </div>
                      <div className="col-2">
                        <h3>0</h3>
                      </div>
                      <div className="col-2">
                        <h3>0</h3>
                      </div>
                      <div className="col-2">
                        <h3>35</h3>
                      </div>
                      <div className="col-2">
                        <h3>32</h3>
                      </div>
                      <div className="col-2">
                        <h3>402</h3>
                      </div>
                    </div>

                    <div className="row grey center">
                      <div className="col-2">
                        <h3>Total</h3>
                      </div>
                      <div className="col-2">
                        <h3>1.234</h3>
                      </div>
                      <div className="col-2">
                        <h3>4.124</h3>
                      </div>
                      <div className="col-2">
                        <h3>3.840</h3>
                      </div>
                      <div className="col-2">
                        <h3>7.762</h3>
                      </div>
                      <div className="col-2">
                        <h3>19.504</h3>
                      </div>
                    </div>
                  </div>

                  <div className="mobile">
                    <div className="row bg-light-grey green">
                      <div className="col-12-sm center">
                        <img src={images.iniciativas.card9.img1} className="card9-icons" />
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Norte</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>678</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Nordeste</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>2.026</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Centro-Oeste</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>1.773</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Sul</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>3.983</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Sudeste</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>8.079</h3>
                      </div>
                    </div>

                    <div className="row bg-light-grey blue">
                      <div className="col-12-sm center">
                        <img src={images.iniciativas.card9.img2} className="card9-icons" />
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Norte</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>487</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Nordeste</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>1.704</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Centro-Oeste</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>1.631</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Sul</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>3.086</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Sudeste</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>8.459</h3>
                      </div>
                    </div>

                    <div className="row bg-light-grey">
                      <div className="col-12-sm center">
                        <img src={images.iniciativas.card9.img3} className="card9-icons" />
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Norte</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>69</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Nordeste</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>394</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Centro-Oeste</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>401</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Sul</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>661</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Sudeste</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>2.564</h3>
                      </div>
                    </div>

                    <div className="row bg-light-grey dark-grey">
                      <div className="col-12-sm center">
                        <img src={images.iniciativas.card9.img4} className="card9-icons" />
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Norte</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>0</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Nordeste</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>0</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Centro-Oeste</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>35</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Sul</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>32</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Sudeste</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>402</h3>
                      </div>
                    </div>

                    <div className="row bg-light-grey grey">
                      <div className="col-12-sm center">
                        <h3>Total</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Norte</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>1.234</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Nordeste</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>4.124</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Centro-Oeste</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>3.840</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Sul</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>7.762</h3>
                      </div>
                      <div className="col-6-sm right">
                        <h3 className="regiao">Sudeste</h3>
                      </div>
                      <div className="col-6-sm">
                        <h3>19.504</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { Card9 };
